export default class HomeHero {
  constructor(element) {
    this.element = element;

    // Verify an image is present
    if (!this.images.length) return;

    // Randomize what image to display
    this.loadRandomlyChoosenImage()
      .then(this.ready());
  }

  loadRandomlyChoosenImage() {
    return new Promise((resolve) => {
      const $images = this.images;
      if ($images.length > 0) {
        $images.forEach((element) => {
          const src = element.getAttribute('data-src');
          const img = new Image();
          img.onload = () => {
            element.src = src;
            resolve();
          };
          img.src = src;
        });
      }
    });
  }

  removeUnselectedImages(selectedImage) {
    return this.images.forEach((image) => {
      if (image !== selectedImage) {
        image.remove();
      }
    });
  }

  ready() {
    return this.element.classList.add('ready');
  }

  get images() {
    return this.element.querySelectorAll('.node-image img');
  }

  get random() {
    const total = Number(this.images.length);
    return Math.floor(Math.random() * total);
  }
}
